import { render, staticRenderFns } from "./intelligentMatching.vue?vue&type=template&id=734e8420&scoped=true"
import script from "./intelligentMatching.vue?vue&type=script&lang=js"
export * from "./intelligentMatching.vue?vue&type=script&lang=js"
import style0 from "./intelligentMatching.vue?vue&type=style&index=0&id=734e8420&prod&scoped=true&lang=css"
import style1 from "./intelligentMatching.vue?vue&type=style&index=1&id=734e8420&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734e8420",
  null
  
)

export default component.exports